import { render, staticRenderFns } from "./publocomotive.vue?vue&type=template&id=1b025993&scoped=true&"
import script from "./publocomotive.vue?vue&type=script&lang=js&"
export * from "./publocomotive.vue?vue&type=script&lang=js&"
import style0 from "./publocomotive.vue?vue&type=style&index=0&id=1b025993&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b025993",
  null
  
)

export default component.exports